import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import SearchBox from "@/components/feature/SearchBox";

const NAV_ITEMS = [
  { to: "/", label: "首页" },
  { to: "/movies", label: "电影" },
  { to: "/tvseries", label: "电视剧" },
  { to: "/news", label: "资讯" },
  { to: "/about", label: "关于" },
];

function isActive(pathname: string, to: string) {
  if (to === "/") return pathname === "/";
  return pathname === to || pathname.startsWith(`${to}/`);
}

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const { pathname } = useLocation();

  const closeAll = () => {
    setMenuOpen(false);
    setSearchOpen(false);
  };

  return (
    <header className="sticky top-0 z-50 border-b border-background-200 bg-background-50/90 backdrop-blur">
      <div className="mx-auto flex h-16 max-w-7xl items-center gap-4 px-4 md:px-6">
        <Link to="/" onClick={closeAll} className="flex shrink-0 items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-lg text-accent-400">
            <i className="ri-movie-2-fill"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="text-lg font-black tracking-tight text-foreground-950">
              白虎影视
            </span>
            <span className="font-label text-[10px] tracking-[0.28em] text-accent-600">
              BAIHU
            </span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              onClick={closeAll}
              className={`whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                isActive(pathname, item.to)
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
              }`}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="ml-auto hidden w-64 lg:block xl:w-72">
          <SearchBox size="md" placeholder="搜索影视…" />
        </div>

        <div className="ml-auto flex items-center gap-1 lg:ml-2">
          <Link
            to="/favorites"
            onClick={closeAll}
            title="我的收藏"
            className="hidden h-10 w-10 items-center justify-center rounded-md text-lg text-foreground-700 transition-colors hover:bg-background-100 md:flex"
          >
            <i className="ri-bookmark-line"></i>
          </Link>
          <button
            type="button"
            aria-label="搜索"
            onClick={() => {
              setSearchOpen((prev) => !prev);
              setMenuOpen(false);
            }}
            className="flex h-10 w-10 items-center justify-center rounded-md text-lg text-foreground-700 transition-colors hover:bg-background-100 lg:hidden"
          >
            <i className="ri-search-line"></i>
          </button>
          <button
            type="button"
            aria-label="菜单"
            onClick={() => {
              setMenuOpen((prev) => !prev);
              setSearchOpen(false);
            }}
            className="flex h-10 w-10 items-center justify-center rounded-md text-xl text-foreground-700 transition-colors hover:bg-background-100 md:hidden"
          >
            <i className={menuOpen ? "ri-close-line" : "ri-menu-line"}></i>
          </button>
        </div>
      </div>

      {searchOpen ? (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 lg:hidden">
          <SearchBox size="md" autoFocus placeholder="搜索影视…" />
        </div>
      ) : null}

      {menuOpen ? (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
          <nav className="grid grid-cols-2 gap-2">
            {NAV_ITEMS.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                onClick={closeAll}
                className={`flex items-center justify-between rounded-md px-4 py-3 text-sm font-medium transition-colors ${
                  isActive(pathname, item.to)
                    ? "bg-primary-500 text-background-50"
                    : "bg-background-100 text-foreground-800"
                }`}
              >
                {item.label}
                <i className="ri-arrow-right-s-line text-lg"></i>
              </NavLink>
            ))}
          </nav>
        </div>
      ) : null}
    </header>
  );
}